export const STRATEGY_LIST_EXPORT_ID = 'strategy-list';

export const STRATEGY_LIST_TITLE = 'Cnf. Listas';

export const LOCALIZED_PROPERTIES = {
  code: 'Codigo',
  name: 'Nombre',
  price_list: 'Lista de Precios',
  liquidation_list: 'Lista de Liquidación',
  promotions_list: 'Lista de Promociones',
  discount_adjustment: 'Ajuste de Precio por Descuento',
  surcharge_adjustment: 'Ajuste de Precio por Recargo',
  discount: 'Descuento',
};
